import { MetricCategory } from '@/modules/shared/adapter';
import { Port } from '@/modules/shared/Port';
import { ReImportSpecification, SensorSensorTypeEnum } from '@/clients/dashboardapi/v2';
import TimeIntervals from '@/assets/js/utils/TimeIntervals';
import { ReImportSpecsWithReferenceDate } from '@/modules/shared/types/ReImportSpecsWithReferenceDate';

export default class ReImportSpecificationUtils {
    public static async resolveReImportSpecifications(affectedReImportSpecs: Map<string, ReImportSpecsWithReferenceDate>): Promise<Map<string, ReImportSpecsWithReferenceDate>> {
        const resultMap = new Map<string, ReImportSpecsWithReferenceDate>();

        for (const [key, specsWithReferenceDate] of affectedReImportSpecs.entries()) {
            const filteredSpecs = await ReImportSpecificationUtils.filterReImportSpecifications(specsWithReferenceDate.specs);

            if (filteredSpecs.length > 0) {
                resultMap.set(key, { specs: filteredSpecs, referenceDate: specsWithReferenceDate.referenceDate });
            }
        }

        return TimeIntervals.resolveIntervalForReImportSpecifications(resultMap);
    }

    private static async filterReImportSpecifications(
        specs: ReImportSpecification[],
    ): Promise<ReImportSpecification[]> {
        const checks = await Promise.all(
            specs.map(async (spec) => {
                if (spec.sensorWrapper.sensorType === SensorSensorTypeEnum.Logs) {
                    return spec;
                }

                if (!spec.sensorWrapper.metricKey) {
                    return null;
                }

                const metric = await Port.metrics.getMetricByKey(spec.sensorWrapper.metricKey);

                const shouldKeep = metric && !ReImportSpecificationUtils.isCalculated(metric.category);

                return shouldKeep ? spec : null;
            }),
        );

        return checks.filter(
            (spec): spec is ReImportSpecification => spec !== null,
        );
    }

    private static isCalculated(metricCategory: MetricCategory): boolean {
        const validCategories = new Set<string>([
            MetricCategory.Calculated,
            MetricCategory.Accounting,
            MetricCategory.LossOfProduction,
            MetricCategory.LossOfRevenue,
        ]);

        return validCategories.has(metricCategory);
    }
}
